module.exports = __webpack_public_path__ + "static/media/logo.68726117.png";